import { studentMessages } from './en-US';

export const programId = '5dceea383eeefd230c991b07';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    messagesWithLocale: {
        'en-US': studentMessages,
    },
};
